// Fix del aviso benigno "ResizeObserver loop completed with undelivered
// notifications." (y su variante "loop limit exceeded").
//
// No es un crash: el navegador lo emite cuando un callback de ResizeObserver
// provoca un reflow que vuelve a cambiar tamaños DENTRO del mismo ciclo de
// entrega. En esta app lo dispara el posicionamiento interno de Radix
// (Dialog/Popper) al abrir el composer de correo: al elegir "Ambos" aparecen dos
// chips de destinatario y, con correos largos, envuelven a otra línea → el
// observer reentra en el mismo tick. El overlay de errores de CRA lo trata como
// fatal aunque sea inofensivo.
//
// En vez de OCULTAR el mensaje (poco confiable: el listener del overlay de CRA se
// registra antes que el código de la app), lo EVITAMOS en la raíz: envolvemos el
// callback en requestAnimationFrame, batcheando la entrega al frame siguiente.
// Así los tamaños se estabilizan antes de la próxima observación y el ciclo
// síncrono se rompe, sin perder entries ni cambiar el resultado del layout.

export function installResizeObserverLoopFix() {
  if (typeof window === "undefined" || !window.ResizeObserver) return;
  if (window.__roLoopFixInstalled) return;
  window.__roLoopFixInstalled = true;

  const NativeResizeObserver = window.ResizeObserver;
  window.ResizeObserver = class PatchedResizeObserver extends NativeResizeObserver {
    constructor(callback) {
      super((entries, observer) => {
        window.requestAnimationFrame(() => {
          callback(entries, observer);
        });
      });
    }
  };
}
